/*
 * RORUVERA - Magic360 on demand.
 *
 * The spin markup is rendered with class "Magic360-lazy" (see snippets/magic360.liquid), so the
 * Magic360 app script (injected by the Magic360 app embed) finds nothing to initialise on page load
 * and the spin frames are not requested. The class is swapped back and Magic360.start() is called
 * when the visitor actually moves towards the 360 media. The spin itself is unchanged.
 *
 * Activation triggers:
 *   - tap on the 360 slide (mobile) / click on a 360 icon -> activate + open fullscreen
 *   - pointerenter on the 360 slide (desktop)
 *   - the 360 slide scrolling into view, but ONLY in the carousel desktop layouts, where reaching
 *     that slide requires carousel navigation. In masonry / collage / fashion every media item is
 *     laid out on the page at once, so "visible" says nothing about intent and observing there would
 *     initialise Magic360 on page load - exactly what the deferral is meant to avoid.
 *
 * Event responsibilities (one user interaction must cause exactly one open):
 *   - the 360 slide owns every click inside it, including the .magic360-icon-fullscreen-open overlay
 *     which covers the whole slide on mobile (see custom.css). That overlay must NOT get a listener
 *     of its own: the click would then be handled by the overlay AND by the slide it bubbles to,
 *     producing two fullscreen button clicks and two history.pushState() entries, which is why the
 *     Android back button needed two presses.
 *   - controls outside the slide (.gallery-icon--360, .magic360-icon-fullscreen-open-thumb) keep
 *     their own listeners; their clicks never bubble through the slide.
 */
(function () {
  var MOBILE = window.matchMedia('(max-width: 899px)');
  var CAROUSEL_LAYOUTS = ['carousel-horizontal', 'carousel-vertical'];
  var POLL_INTERVAL = 100;
  /* Magic360 adds its fullscreen button only once the first frames are in, which takes several
     seconds on a slow phone, so both waits must cover a slow mobile connection. Giving up early
     made the first tap do nothing (the second tap then worked because the viewer was ready). */
  var LIB_TRIES = 300; // 30 s for the Magic360 app script
  var BUTTON_TRIES = 300; // 30 s for the viewer to become ready after start()

  var slide = null;
  var activated = false; // Magic360.start() has been called for the spin
  var activating = false; // waiting for the Magic360 app script
  var openInFlight = false;

  function isAndroid() {
    return /Android/i.test(navigator.userAgent);
  }

  /* Calls onReady with the first truthy result of test(), or with null once tries run out. */
  function poll(test, onReady, tries) {
    var result = test();
    if (result) return onReady(result);
    if (tries <= 0) return onReady(null);
    setTimeout(function () {
      poll(test, onReady, tries - 1);
    }, POLL_INTERVAL);
  }

  /* Reuses the theme spinner already rendered in the 360 slide, so the first tap is not silent. */
  function setActivating(state) {
    if (slide) slide.classList.toggle('magic360-activating', state);
  }

  function activate() {
    if (activated || activating) return true;
    var spin = slide && slide.querySelector('.Magic360-lazy, .Magic360');
    if (!spin) return false;
    activating = true;
    /* The poster frame is lazy; iOS Safari does not load a lazy image in an off-screen carousel
       slide, and Magic360 waits for it before it starts. Load it now. */
    var lazyImgs = spin.querySelectorAll('img[loading="lazy"]');
    for (var i = 0; i < lazyImgs.length; i++) lazyImgs[i].loading = 'eager';
    poll(
      function () {
        return window.Magic360 && typeof window.Magic360.start === 'function' ? window.Magic360 : null;
      },
      function (lib) {
        activating = false;
        /* Script never arrived: stay lazy so the next interaction tries again. */
        if (!lib) return;
        spin.classList.remove('Magic360-lazy');
        spin.classList.add('Magic360');
        activated = true;
        lib.start();
      },
      LIB_TRIES
    );
    return true;
  }

  function openFullscreen() {
    /* A second interaction while the viewer is still starting must not open it twice. */
    if (openInFlight) return;
    openInFlight = true;
    activate();
    setActivating(true);
    poll(
      function () {
        return (slide && slide.querySelector('.m360-icon-fullscreen-open')) || document.querySelector('.m360-icon-fullscreen-open');
      },
      function (btn) {
        openInFlight = false;
        setActivating(false);
        if (!btn) return;
        btn.click();
        if (isAndroid()) {
          history.pushState({ magic360: true }, '');
        }
      },
      BUTTON_TRIES
    );
  }

  /* Bring the 360 slide into view first, so a tap on a control outside the slide (the small 360
     icon under the gallery, the 360 thumbnail) starts the viewer exactly like a tap on the slide. */
  function showSlide() {
    var swiperEl = slide && slide.closest('.swiper');
    var swiper = swiperEl && swiperEl.swiper;
    if (!swiper || !swiper.slides) return;
    var index = Array.prototype.indexOf.call(swiper.slides, slide);
    if (index !== -1 && index !== swiper.activeIndex) swiper.slideTo(index, 0);
  }

  function openFromControl() {
    showSlide();
    openFullscreen();
  }

  function observeCarouselSlide() {
    var gallery = slide.closest('.wt-product__gallery');
    if (!gallery || !('IntersectionObserver' in window)) return;

    /* Wait for gallery.js: until it has initialised Swiper the slides are stacked in the document
       and the 360 slide can already intersect the viewport without any navigation. */
    poll(
      function () {
        return gallery.classList.contains('loaded') ? gallery : null;
      },
      function (ready) {
        if (!ready || MOBILE.matches) return;
        var io = new IntersectionObserver(
          function (entries) {
            if (MOBILE.matches) return;
            for (var i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                activate();
                io.disconnect();
                return;
              }
            }
          },
          { threshold: 0.3 }
        );
        io.observe(slide);
      },
      50
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    slide = document.querySelector('.wt-product__gallery [data-media-id="360"]');

    /* Controls rendered outside the 360 slide. */
    ['.magic360-icon-fullscreen-open-thumb', '.gallery-icon--360'].forEach(function (selector) {
      var el = document.querySelector(selector);
      if (el) el.addEventListener('click', openFromControl);
    });

    if (slide) {
      slide.addEventListener('click', function (e) {
        /* Desktop drags the spin in place; only mobile opens fullscreen from the slide. */
        if (!MOBILE.matches) return;
        /* Leave the photoswipe trigger to the gallery. */
        if (e.target.closest && e.target.closest('a[data-pswp-width]')) return;
        e.preventDefault();
        openFullscreen();
      });

      slide.addEventListener('pointerenter', function () {
        if (!MOBILE.matches) activate();
      });

      var container = slide.closest('[desktop-layout]');
      var layout = container ? container.getAttribute('desktop-layout') : '';
      if (!MOBILE.matches && CAROUSEL_LAYOUTS.indexOf(layout) !== -1) {
        observeCarouselSlide();
      }
    }

    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.magic360) {
        var closeBtn = document.querySelector('.m360-icon.m360-icon-fullscreen-close');
        if (closeBtn) closeBtn.click();
        history.pushState({ magic360: false }, '');
      }
    });
  });
})();
